<template>
  <v-form ref="form">
    <v-simple-table class>
      <template v-slot:default>
        <tbody>
          <tr>
            <td class="text-left">Tổng Tiền:</td>
            <td class="text-right">{{sum | formatMoney}}</td>
          </tr>
          <tr>
            <td class="text-left">Giảm Giá:</td>
            <td class="text-right">
              <currency-input dense v-model="discount"></currency-input>
            </td>
          </tr>
          <tr>
            <td class="text-left nowrap">Học viên Cần Trả:</td>
            <td
              class="text-right body-1 font-weight-black green--text nowrap"
            >{{total | formatMoney}}</td>
          </tr>
          <tr>
            <td class="text-left">Học viên Thanh Toán:</td>
            <td class="text-right">
              <currency-input dense disabled v-model="paid"></currency-input>
            </td>
          </tr>
          <tr>
            <td class="text-left nowrap">Học viên Nợ:</td>
            <td
              class="text-right body-1 font-weight-black red--text nowrap"
            >{{liabilities | formatMoney}}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <StudentListDialog :students="students"></StudentListDialog>
    <date-picker :date.sync="date" label="Ngày" placeholder="Nhập Ngày" dense></date-picker>
    <v-textarea full-width no-resize placeholder="Tags" v-model="notes" dense :height="50"></v-textarea>
  </v-form>
</template>
<script>
import { mapState } from 'vuex'
import CurrencyInput from '@/components/basic/input/CurrencyInput.vue'
import utils from '@/plugins/utils.js'
import DatePicker from '@/components/basic/picker/DateIOSPicker.vue'
import StudentListDialog from '@/modules/sales/StudentNewTuitionDialog.vue'
import _ from 'lodash'
export default {
  components: {
    CurrencyInput,
    DatePicker,
    StudentListDialog
  },
  props: {
    students: Array,
    products: Array
  },
  data () {
    return {
      discount: '0',
      paid: '0',
      notes: '',
      date: new Date().toISOString(),
      student: null,
      customerName: '',
      customerPhone: '',
      paymentType: 'cash',
      loading: false
    }
  },
  created () {},
  computed: {
    ...mapState('constant', ['billStatus', 'paymentTypes']),
    sum () {
      return this.products.reduce(
        (acc, cur) => (acc += cur.price * cur.quantity),
        0
      )
    },
    total () {
      return this.sum - parseInt(this.discount)
    },
    liabilities () {
      return this.total - parseInt(this.paid)
    }
  },
  methods: {
    getValues () {
      return this.students.map((s, i) => ({
        code: 'DH-' + Math.round(Date.now() / 1000) + i,
        tags: this.notes,
        notes: this.notes,
        status: this.liabilities > 0 ? 'liabilities' : 'paid',
        liabilities: this.liabilities,
        total: this.total,
        items: this.products,
        discount: parseInt(this.discount),
        sum: parseInt(this.sum),
        student: _.get(s, 'id'),
        paymentType: this.paymentType,
        customerPaid: parseInt(this.paid) || 0,
        customerName: s.name,
        customerPhone: s.phone,
        type: 'tuition',
        date: this.date
      }))
    }
  },
  filters: {
    formatMoney (amount) {
      return utils.formatMoney(amount)
    }
  },
  watch: {
    total (total) {
      this.paid = 0
    }
  }
}
</script>
<style scoped>
.nowrap {
  white-space: nowrap;
}
td {
  padding-left: 0 !important;
}
</style>
